import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { CategoryLandingPropsProvider } from './components/stack/hooks/content/useCategoryLandingProps';
import { CategoryLanding } from './components/stack/views/CategoryLanding/CategoryLanding';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('content-hub');
  if (!container) return drawDefaultLayout();

  const root = createRoot(container);
  root.render(
    <BaseContentProvider>
      <CategoryLandingPropsProvider>
        <DefaultLayout>
          <CategoryLanding />
        </DefaultLayout>
      </CategoryLandingPropsProvider>
    </BaseContentProvider>
  );
});
